import EmailConfiguratorActionBar from './EmailConfiguratorActionBar';
import EmailConfiguratorContent from './EmailConfiguratorContent';

const EmailConfigurator = {
  Content: EmailConfiguratorContent,
  ActionBar: EmailConfiguratorActionBar,
};

export default EmailConfigurator;
